import __wbg_init from '../pkg/jsegd'
import { Address, AddressController } from './providers/address'
import { Bank, BankController } from './providers/bank'
import { DocxRenderer } from './providers/docx'
import type { DocxRendererOptions } from './providers/docx'
import { Municipality, MunicipalityController } from './providers/municipality'

await __wbg_init()

export {
    Address,
    AddressController,
    Bank,
    BankController,
    DocxRenderer,
    Municipality,
    MunicipalityController,
}
export type { DocxRendererOptions }
